import AppWrapper from "../../components/cm/AppWrapper";
import SideBarMain from "../../components/cm/SideBarMain";
import ActionableItems from "../../components/modules/actionable-items";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <div className="h-[calc(95vh-64px)] overflow-hidden rounded-b-[15px] bg-white p-4">
        <ActionableItems title={"Actionable Items"} />
      </div>
    </AppWrapper.WithSidebar>
  );
};
